module.exports = __webpack_public_path__ + "static/media/5.1.be7f1819.png";